import { useEffect } from 'react'
import { useRef } from 'react'
import { useState } from 'react'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { Link } from 'react-router-dom'
import { Monitor, MonitorViewModel } from '../../shared/types'
import { useUpdateMonitorMutation } from 'services/monitor'
import { DateTime } from 'luxon'
import { SxProps } from '@mui/material'
import styles from './MonitorCard.module.css'

interface MonitorCardProps {
    monitor: MonitorViewModel;
    onDelete: (monitor: Monitor) => void;
};

export const MonitorCard = (props: MonitorCardProps): JSX.Element => {
    const {
        monitor,
        onDelete,
        ...other
    } = props

    const [open, setOpen] = useState<boolean>(false)
    const anchorRef = useRef<HTMLButtonElement>(null)
    const prevOpen = useRef(open)
    const [updateMonitorMutation] = useUpdateMonitorMutation()

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [
        open
    ])

    const onDeleteHandler = async () => {
        onDelete(monitor);
    }

    const propertyNameStyle: SxProps = {
        fontSize: '20px',
        fontWeight: 700
    }

    const propertyValueStyle: SxProps = {
        fontSize: '20px',
        marginLeft: '20px'
    }
    const propertyRowStyle: SxProps = {
        display: 'inline-grid',
        margin: '14px 0 0 0'
    }

    
    return (
        <div className={styles.MonitorCard_Root}>
            <Card variant="outlined" sx={{ maxWidth: 385, border: 'none' }}>
                <CardContent sx={{ p: 0 }}>  
                    <Box sx={{
                        bgcolor: '#FFF',
                        padding: '20px 24px',
                        border: `1px solid rgba(0, 0, 0, 0.12)`
                    }}
                    >
                        <Box sx={{ flexGrow: 1 }}>
                            <Link to={`/spy/${monitor.id}/monitorrun`} style={{ color: '#FFF', textDecoration: 'none' }}>
                                <Box sx={{ fontWeight: '700', m: 0, color: '#000', fontSize: '24px' }}>
                                    {monitor.title}
                                </Box>
                            </Link>
                        </Box>
                    </Box>
                    <Box sx={{
                        backgroundColor: `rgba(247, 247, 247, 1)`,
                        borderBottom: `1px solid rgba(0, 0, 0, 0.12)`,
                        borderLeft: `1px solid rgba(0, 0, 0, 0.12)`,
                        borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
                    }}>
                        <Box sx={{padding: '20px 24px'}}>
                            <Box className={styles.MonitorCard_PropertyListContainer}>
                                <Box sx={ propertyRowStyle }>
                                    <Box sx={{display: 'flex'}}>
                                        <Box sx={propertyNameStyle}>
                                            Location:
                                        </Box>
                                        <Box sx={propertyValueStyle}>
                                            {monitor.locations.join(', ')}
                                        </Box>
                                    </Box>
                                </Box>
                                <Box sx={propertyRowStyle}>
                                    <Box sx={{ display: 'flex' }}>
                                        <Box sx={propertyNameStyle}>
                                            Platform:
                                        </Box>
                                        <Box sx={propertyValueStyle}>
                                            {
                                                monitor.platform.name
                                            }
                                        </Box>
                                    </Box>
                                </Box>
                                <Box sx={propertyRowStyle}>
                                    <Box sx={{ display: 'flex' }}>
                                        <Box sx={propertyNameStyle}>
                                            Created:
                                        </Box>
                                        <Box sx={propertyValueStyle}>
                                            {
                                                DateTime.fromISO(monitor.timestampCreatedUtc).toFormat('M/dd/yyyy hh:mm  a')                                               
                                            }
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: `center`, padding: '24px', gap: '10px' }}>
                            <Link to={`/spy/${monitor.id}/monitorrun`} style={{ margin: 0 }}>
                                <Button
                                    color="success"
                                    size="small"
                                    variant="contained"
                                    sx={{
                                        minWidth: 100
                                    }}
                                >
                                    Results
                                </Button >
                            </Link>
                            <Link to={`/spy/${monitor.id}`} style={{ margin: 0 }}>
                                <Button
                                    color="primary"
                                    size="small"
                                    variant="contained"
                                    sx={{
                                        minWidth: 100
                                    }}
                                >
                                    Edit
                                </Button >
                            </Link>
                            <Button
                                color="error"
                                size="small"
                                variant="contained"
                                onClick={onDeleteHandler}
                                sx={{
                                    minWidth: 100,
                                    margin: 0
                                }}
                            >
                                Delete
                            </Button >


                        </Box>             
                    </Box>
                </CardContent>
                <CardActions>
                   
                </CardActions>
            </Card>
        </div>
    )
}